// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__HKMKe","my-credit":"Footer_my-credit__h6L-X","credits":"Footer_credits__gLQud"};